import { Element, useEditor, useNode } from "@craftjs/core"
import { PlusIcon } from "lucide-react"

import BasePreview, { Action } from "@/components/builder/blocks/base"
import { define, prop } from "@/components/builder/utils"

import { GridItemBlock } from ".."

function GridContainer({ children, ...props }) {
  const { id } = useNode()

  const { actions, query: { createNode } } = useEditor();

  const handleAddItem = () => {
    if (!children) return
    actions.add(createNode(<Element is={GridItemBlock} canvas />), id)
  }

  return <BasePreview {...props} customActions={<>
    <Action onClick={handleAddItem} className='rounded-full! p-1!'>
      <PlusIcon size={12} />
    </Action>
  </>}>
    <div>
      {children}
    </div>
  </BasePreview>
}

export default define('grid-container', GridContainer)
  .property(prop.predefined.customClass())
  .property(...prop.predefined.layout())
  .property(...prop.predefined.appearance())
  .property(prop.predefined.attributes())
  .defaultProps({
    grid: { columns: 2 },
    layoutType: "grid",
  })
  .ignoreResetProps(['variant', 'grid.columns', 'grid.rows', 'layoutType'])
  .build()
